import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Phone = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.457 3c-1.78.104-3.301 1.165-4.017 2.82-.676 1.563-.574 3.05.312 4.544a27.9 27.9 0 0 0 9.908 9.901c1.332.787 2.685.932 4.14.442a4.68 4.68 0 0 0 3.2-4.166 740 740 0 0 1-4.16-1.56q-.342.346-.686.689l-.56.561q-.089.091-.172.188l-.1.114a.88.88 0 0 1-1.14.144c-2.723-1.806-4.965-4.04-6.852-6.83a.88.88 0 0 1 .107-1.115l.481-.481q.553-.553 1.1-1.095-.684-1.815-1.364-3.63z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Phone) as SvgIcon;
export { ForwardRef as ReactComponent };
